// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let Loader = require("../../uikit/reason/atoms/Loader/Loader.bs.js");
let ButtonsV5 = require("../../uikit/reason/atoms/Buttons/ButtonsV5.bs.js");
let Primitive_option = require("@rescript/runtime/lib/js/Primitive_option.js");
let JsxRuntime = require("react/jsx-runtime");
let RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
let DashboardCardComponents__Tw = require("./DashboardCardComponents__Tw.bs.js");
let ChapterDashboardBuyerNeedStats_query_graphql = require("../../__generated__/ChapterDashboardBuyerNeedStats_query_graphql.bs.js");

function ChapterDashboard__BuyerNeedStats$CardBodyContainer(props) {
  return JsxRuntime.jsxs(JsxRuntime.Fragment, {
    children: [
      props.children,
      props.showSearchLink ? JsxRuntime.jsx("div", {
          children: JsxRuntime.jsx(DashboardCardComponents__Tw.Footer.make, {
            href: "/client_needs",
            linkText: "Search all broadcast client needs"
          }),
          className: "mt-8"
        }) : null
    ]
  });
}

let CardBodyContainer = {
  make: ChapterDashboard__BuyerNeedStats$CardBodyContainer
};

function ChapterDashboard__BuyerNeedStats$EmptyState(props) {
  return JsxRuntime.jsx(ChapterDashboard__BuyerNeedStats$CardBodyContainer, {
    showSearchLink: true,
    children: JsxRuntime.jsx(DashboardCardComponents__Tw.EmptyStateContainer.make, {
      children: JsxRuntime.jsxs("div", {
        children: [
          JsxRuntime.jsx("p", {
            children: "There have been no client needs added in your TAN chapter recently."
          }),
          JsxRuntime.jsx("p", {
            children: JsxRuntime.jsxs("span", {
              children: [
                JsxRuntime.jsx(ButtonsV5.Link.make, {
                  href: "/properties/new",
                  children: "Add your sellers"
                }),
                " so you won't miss new buyer needs on TAN that match."
              ]
            })
          })
        ],
        className: "text-left space-y-7"
      })
    })
  });
}

let EmptyState = {
  EmptyStateContainer: undefined,
  make: ChapterDashboard__BuyerNeedStats$EmptyState
};

function ChapterDashboard__BuyerNeedStats$ErrorState(props) {
  return JsxRuntime.jsx(ChapterDashboard__BuyerNeedStats$CardBodyContainer, {
    showSearchLink: true,
    children: JsxRuntime.jsx(DashboardCardComponents__Tw.EmptyStateContainer.make, {
      children: JsxRuntime.jsx("div", {
        children: "There was a problem loading the buyer need stats",
        className: "flex items-center"
      })
    })
  });
}

let ErrorState = {
  EmptyStateContainer: undefined,
  make: ChapterDashboard__BuyerNeedStats$ErrorState
};

function ChapterDashboard__BuyerNeedStats$LoadingState(props) {
  return JsxRuntime.jsx(ChapterDashboard__BuyerNeedStats$CardBodyContainer, {
    showSearchLink: false,
    children: JsxRuntime.jsx(DashboardCardComponents__Tw.LoadingStateContainer.make, {
      children: JsxRuntime.jsx(Loader.make, {})
    })
  });
}

let LoadingState = {
  make: ChapterDashboard__BuyerNeedStats$LoadingState
};

function ChapterDashboard__BuyerNeedStats$BuyerNeedStatsWidget(props) {
  let purchased = props.purchased;
  let activePrivate = props.activePrivate;
  let activePublic = props.activePublic;
  if (activePublic === 0 && activePrivate === 0 && purchased === 0) {
    return JsxRuntime.jsx(ChapterDashboard__BuyerNeedStats$EmptyState, {});
  }
  return JsxRuntime.jsx(ChapterDashboard__BuyerNeedStats$CardBodyContainer, {
    showSearchLink: true,
    children: JsxRuntime.jsxs("div", {
      children: [
        JsxRuntime.jsx("div", {
          children: JsxRuntime.jsx(DashboardCardComponents__Tw.StatsDisplayer.make, {
            href: "/client_needs",
            label: "Broadcast",
            value: activePublic,
            subLabel: "Client needs"
          }),
          className: "flex-1"
        }),
        JsxRuntime.jsx("div", {
          children: JsxRuntime.jsx(DashboardCardComponents__Tw.StatsDisplayer.make, {
            label: "Quiet",
            value: activePrivate,
            subLabel: "Buyer needs"
          }),
          className: "flex-1"
        }),
        JsxRuntime.jsx("div", {
          children: JsxRuntime.jsx(DashboardCardComponents__Tw.StatsDisplayer.make, {
            href: "/client_needs?purchasedOrRented=true",
            label: "Purchased / Rented",
            value: purchased,
            subLabel: "last 90 days"
          }),
          className: "flex-1"
        })
      ],
      className: "flex flex-col md:flex-row gap-4"
    })
  });
}

let BuyerNeedStatsWidget = {
  make: ChapterDashboard__BuyerNeedStats$BuyerNeedStatsWidget
};

let convertFragment = ChapterDashboardBuyerNeedStats_query_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, ChapterDashboardBuyerNeedStats_query_graphql.node, convertFragment, fRef);
}

function use(fRef) {
  return RescriptRelay_Fragment.useFragment(ChapterDashboardBuyerNeedStats_query_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, ChapterDashboardBuyerNeedStats_query_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(ChapterDashboardBuyerNeedStats_query_graphql.node, convertFragment, fRef);
}

let QueryFragment = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

function ChapterDashboard__BuyerNeedStats(props) {
  let query = RescriptRelay_Fragment.useFragment(ChapterDashboardBuyerNeedStats_query_graphql.node, convertFragment, props.query);
  let match = query.chapterBuyerNeedStats;
  if (match === undefined) {
    return JsxRuntime.jsx(ChapterDashboard__BuyerNeedStats$ErrorState, {});
  }
  let match$1 = match.activePrivate;
  if (match$1 === undefined) {
    return JsxRuntime.jsx(ChapterDashboard__BuyerNeedStats$ErrorState, {});
  }
  let activePrivate = match$1.count;
  if (activePrivate === undefined) {
    return JsxRuntime.jsx(ChapterDashboard__BuyerNeedStats$ErrorState, {});
  }
  let match$2 = match.activePublic;
  if (match$2 === undefined) {
    return JsxRuntime.jsx(ChapterDashboard__BuyerNeedStats$ErrorState, {});
  }
  let activePublic = match$2.count;
  if (activePublic === undefined) {
    return JsxRuntime.jsx(ChapterDashboard__BuyerNeedStats$ErrorState, {});
  }
  let match$3 = match.purchased;
  if (match$3 === undefined) {
    return JsxRuntime.jsx(ChapterDashboard__BuyerNeedStats$ErrorState, {});
  }
  let purchased = match$3.count;
  if (purchased !== undefined) {
    return JsxRuntime.jsx(ChapterDashboard__BuyerNeedStats$BuyerNeedStatsWidget, {
      activePublic: activePublic | 0,
      activePrivate: activePrivate | 0,
      purchased: purchased | 0
    });
  } else {
    return JsxRuntime.jsx(ChapterDashboard__BuyerNeedStats$ErrorState, {});
  }
}

let DashboardCardComponents;

let make = ChapterDashboard__BuyerNeedStats;

exports.DashboardCardComponents = DashboardCardComponents;
exports.CardBodyContainer = CardBodyContainer;
exports.EmptyState = EmptyState;
exports.ErrorState = ErrorState;
exports.LoadingState = LoadingState;
exports.BuyerNeedStatsWidget = BuyerNeedStatsWidget;
exports.QueryFragment = QueryFragment;
exports.make = make;
/* Loader Not a pure module */
